export default "__VITE_ASSET__Bh12OY1l__"